import * as Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';

export const generateDeviceId = () => {
  const deviceId = uuidv4();
  Cookies.set('deviceId', deviceId, { expires: 365 });
  return deviceId;
};

export const getDeviceId = () => {
  const deviceId = Cookies.get('deviceId');
  if (deviceId) {
    return deviceId;
  } else {
    return generateDeviceId();
  }
};

export default {
  generateDeviceId,
  getDeviceId,
};
